
import { useState } from 'react';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import ServicesSection from './components/ServicesSection';
import ValidationSection from './components/ValidationSection';
import Footer from './components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <HeroSection />
      <ProblemSection />
      <ServicesSection />
      <ValidationSection />
      <Footer />
    </div>
  );
};

export default HomePage;
